import { ButtonGroup } from '@subaio/components'

import { asContainer } from 'lib/container'

import { ButtonSolid } from 'components/Buttons'
import { HeaderIconUnauthenticated } from 'components/Icons'
import { SplashScreen } from 'components/Layout'

export const container = asContainer<{}>()({
	authentication: { type: 'public' },
	Running: ({ loginDeveloper }) => (
		<SplashScreen title='You are not logged in' icon={<HeaderIconUnauthenticated />}>
			<ButtonGroup center>
				<ButtonSolid label='Login' onClick={loginDeveloper} />
			</ButtonGroup>
		</SplashScreen>
	),
})
